import { Link } from "react-router-dom";
import { ChevronDown, Camera } from "lucide-react";
import { NavbarMenuItemProps } from "./types";

export interface NavbarDropdownProps {
  title: string;
  isOpen: boolean;
  toggleDropdown: () => void;
  items: NavbarMenuItemProps[];
}

export const NavItem = ({ name, path, onClick }: NavbarMenuItemProps) => {
  return (
    <Link to={path} className="text-fabre-gray hover:text-fabre-green font-medium" onClick={onClick}>
      {name}
    </Link>
  );
};

export const NavDropdown = ({ title, isOpen, toggleDropdown, items }: NavbarDropdownProps) => {
  // Identify if any item has a submenu
  const hasNestedSubmenu = items.some(item => item.submenu && item.submenu.length > 0);
  
  return (
    <div className="relative">
      <button 
        className="text-fabre-gray hover:text-fabre-green font-medium flex items-center"
        onClick={toggleDropdown}
      >
        {title} <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="absolute z-10 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div className="py-1">
            {items.map(item => (
              item.submenu ? (
                <div key={item.path} className="relative group">
                  <Link 
                    to={item.path} 
                    className="flex items-center justify-between w-full px-4 py-2 text-sm text-fabre-gray hover:bg-fabre-lightgreen" 
                  >
                    <div className="flex items-center">
                      {item.icon && <item.icon className="h-4 w-4 mr-2" />}
                      {item.name}
                    </div>
                    <ChevronDown className="ml-1 h-4 w-4 -rotate-90" />
                  </Link>
                  
                  <div className="hidden group-hover:block absolute left-full top-0 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-20">
                    <div className="py-1">
                      {item.submenu.map(subItem => (
                        <Link 
                          key={subItem.path} 
                          to={subItem.path} 
                          className="flex items-center px-4 py-2 text-sm text-fabre-gray hover:bg-fabre-lightgreen" 
                          onClick={subItem.onClick}
                        >
                          {subItem.icon && <subItem.icon className="h-4 w-4 mr-2" />}
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  className="flex items-center px-4 py-2 text-sm text-fabre-gray hover:bg-fabre-lightgreen" 
                  onClick={item.onClick}
                >
                  {item.name === "Photos des sites" && <Camera className="h-4 w-4 mr-2" />}
                  {item.icon && <item.icon className="h-4 w-4 mr-2" />}
                  {item.name}
                </Link>
              )
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
